import { useDepartmentText } from 'model/DepartmentTerminology';
import { useMemo } from 'react';
import { SPECIAL_PLACEHOLDERS } from 'pages/revisions-module/template-editor/editors/template/extensions/placeholder/Placeholder';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { usePipelineData } from 'pages/revisions-module/template-editor/editors/pipeline/PipelineDataProvider';
import { useDepartmentPlaceholders } from 'pages/revisions-module/template-editor/editors/template/extensions/placeholder/department-placeholders';

/**
 * Creates styles for placeholders based on the form inputs.
 */
export function useInjectFieldNameStyles() {
  const departmentText = useDepartmentText();
  const departmentPlaceholders = useDepartmentPlaceholders();
  const { allInputs } = useFormInputs();
  const { placeholderGroups: pipelinePlaceholderGroups } = usePipelineData();

  return useMemo(() => {
    const styles: Record<string, React.CSSProperties> = {};

    const inputSpecs = [
      ...allInputs.map(({ spec }) => spec),
      ...allInputs
        .filter(({ spec }) => spec.type === 'safetyPoint')
        .map(({ spec }) => ({ ...spec, name: `${spec.name}.value` })),
      ...SPECIAL_PLACEHOLDERS.map((placeholder) =>
        placeholder.name === '_department'
          ? { ...placeholder, label: departmentText('Položka úrovne', 'Stredisko') }
          : placeholder.name === '_departmentPath'
          ? { ...placeholder, label: departmentText('Celá cesta položky úrovne', 'Celá cesta strediska') }
          : placeholder
      ),
      ...pipelinePlaceholderGroups.flatMap((group) => group.placeholders),
      ...departmentPlaceholders,
    ];

    for (const spec of inputSpecs) {
      styles[`& .ProseMirror [data-inject-field-name="${spec.name}"]::before`] = {
        content: `"${spec.label.replace(/"/g, '\\"')}"`,
        outline: 'none',
      };
    }

    return styles;
  }, [allInputs, pipelinePlaceholderGroups, departmentText, departmentPlaceholders]);
}
